import styled from "styled-components";
import { palette, size } from "styled-theme";

const Wrapper = styled.footer`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 90px;
  background-color: ${palette("footer", 0)};
  color: ${palette("color", 15)};
  font-size: 12px;
  align-items: center;
  border-top: 1px solid rgba(0, 0, 0, 0.08);

  .ApprovalText {
    text-align: left;
    padding: 0 35px 0 15px;
  }

  .mobile-only {
    display: none; 
  }

  @media only screen and (max-width: ${size("S")}) {
    flex-direction: column-reverse;
    justify-content: center;
    border-top: none;
    font-size: 12px;
    height: auto;

    .ApprovalText {
      text-align: center;
      padding: 10px 60px 35px;
    }

    .mobile-only {
      display: block; 
    }
  }

  @media only screen and (min-width: ${size("S")}) and (max-width: ${size("M")}) {
    .ApprovalText {
      max-width: 350px;
    }
  }

  @media only screen and (max-width: ${size("M")}) {
    font-size: 10px;
  }

  @media only screen and (min-width: ${size("M")}) and (max-width: ${size("L")}) {
    .ApprovalText {
      max-width: 500px;
      padding: 0 55px 0 15px;
    }
  }

  @media only screen and (min-width: ${size("L")}) and (max-width: ${size("LG")}) {
    .ApprovalText {
      max-width: 800px;
    }
  }

  @media only screen and (min-width: ${size("LG")}) {
    .ApprovalText {
      max-width: 1000px;
    }
  }
`;

export default Wrapper;

